/**
 * Mirror of the backend's `src/common/http/api-response.types.ts`.
 *
 * The backend is the source of truth for this contract. When it changes there, change it here
 * in the same pull request — the two repositories share no package, only this agreement.
 */

export const ERROR_CODES = {
  BAD_REQUEST: 'BAD_REQUEST',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  UNAUTHORIZED: 'UNAUTHORIZED',
  FORBIDDEN: 'FORBIDDEN',
  NOT_FOUND: 'NOT_FOUND',
  CONFLICT: 'CONFLICT',
  PAYLOAD_TOO_LARGE: 'PAYLOAD_TOO_LARGE',
  SERVICE_UNAVAILABLE: 'SERVICE_UNAVAILABLE',
  INTERNAL_ERROR: 'INTERNAL_ERROR',
} as const;

export type ErrorCode = (typeof ERROR_CODES)[keyof typeof ERROR_CODES];

export interface PaginationMeta {
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
}

export interface ValidationIssue {
  path: string;
  message: string;
}

export interface ApiSuccessResponse<T> {
  success: true;
  data: T;
  meta?: PaginationMeta;
}

export interface ApiErrorBody {
  code: ErrorCode;
  message: string;
  details?: ValidationIssue[];
  requestId: string;
}

export interface ApiErrorResponse {
  success: false;
  error: ApiErrorBody;
}

export type ApiResponse<T> = ApiSuccessResponse<T> | ApiErrorResponse;

/** A paginated list as the http client returns it: the `data` array plus the envelope's `meta`. */
export interface Page<T> {
  items: T[];
  meta: PaginationMeta;
}

/** Query parameters every paginated list endpoint accepts (`pageSize` max 100). */
export interface PageRequest {
  page: number;
  pageSize: number;
}
